module.exports = __webpack_public_path__ + "img/vibrant-young-population.58400153.jpg";